import { useTranslation } from 'react-i18next';
import { useLocale } from '../hooks/useLocale';
import { useCart } from '../contexts/CartContext';
import { trackClick } from '../services/analyticsService';
import { formatPrice as fmtPrice } from '../utils/format';
import { productListing } from '../lib/imageProxy';
import BlurImage from './BlurImage';

const AllyProductCard = ({ product }) => {
  const locale = useLocale();
  const { t } = useTranslation('product');
  const { addToCart } = useCart();

  const isAvailable = product.is_active !== false && !product.is_sold_out;

  const handleAddToCart = (e) => {
    e.stopPropagation();
    if (!isAvailable) return;
    trackClick(`add-to-cart-${product.id}`, 'button', 'Agregar al Carrito', {
      productId: product.id,
      productName: product.name,
      productPrice: product.price,
      source: 'ally',
    });
    addToCart({ ...product, isSoldOut: false, isPreorder: false, source: 'ally' });
  };

  return (
    <div className="product-card ally-product-card">
      <div className="product-image">
        <BlurImage
          src={productListing(product.image)}
          alt={product.name}
          loading="lazy"
          objectFit="contain"
          onError={(e) => {
            e.currentTarget.src = 'https://via.placeholder.com/300x250/f8f9fa/333?text=Producto';
          }}
        />
      </div>
      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        <p className="ally-product-artist" style={{ visibility: product.artist ? 'visible' : 'hidden' }}>
          {product.artist || ' '}
        </p>
        <p className="ally-product-description" style={{ visibility: product.description ? 'visible' : 'hidden' }}>
          {product.description || ' '}
        </p>
        <p className="product-price">{fmtPrice(product.price, 'MXN', locale)}</p>
        <button
          className="btn btn-primary"
          onClick={handleAddToCart}
          disabled={!isAvailable}
          style={{ width: '100%', opacity: isAvailable ? 1 : 0.5, cursor: isAvailable ? 'pointer' : 'not-allowed', marginTop: 'auto' }}
        >
          {isAvailable ? t('addToCart') : t('soldOut')}
        </button>
      </div>
    </div>
  );
};

export default AllyProductCard;
